module.exports = __webpack_public_path__ + "img/left.23b55faf.webp";